import styles from './List.css'
import InfiniteScroll from 'react-infinite-scroller'
import Row from './Row'

class List extends React.Component {
  render () {
    const {openRightColumn} = this.props
    return (<div className={styles['wrapper']}>
      <div className='full-height'>
        <div className={`${styles['leftcol']} no-padding`} id='mk-col-left'>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={`${openRightColumn ? 'col-md-3' : 'col-md-4'}`}>Role Name</th>
                <th className={`${openRightColumn ? 'col-md-3' : 'col-md-4'}`}>Employee Assigned</th>
                <th className={`${openRightColumn ? 'col-md-6' : 'col-md-4'}`}>Access</th>
              </tr>
            </thead>
          </table>
          <div className={`${styles['table-content-wrapper']} role-table-content-wrapper`}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this.props.onReachBottom}
              hasMore={this.props.hasMore}
              useWindow={false}
              threshold={10}
              initialLoad={false}>
              <table className={styles['table-content']}>
                <tbody>
                  {
                    this.props.role.roles.map(role => {
                      return <Row
                        role={role}
                        isSelected={this.props.role.roleDetail !== null && role.id === this.props.role.roleDetail.id}
                        onClickRow={this.props.onClickRow}
                        userPermissions={this.props.userPermissions}
                        openRightColumn={openRightColumn}
                      />
                    })
                  }
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>)
  }
}

export default List



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/List/List.js